// tslint:disable
/**
 * TC API
 * TestCollab is a test management tool that helps development teams carry out testing effectively and avoid failures. # Introduction This is an API documentation for TestCollab 2.   # Authentication TestCollab supports two forms of authentication:   - An <b>API token</b> is required to make API calls. The token can be generated from user's profile; to obtain it login to your TestCollab account and go to ['My Profile Settings'](https://testcollab.io/my_profile) and switch to API Token tab. Click on \"Generate new API token\", Once the token is generated it can be sent as a query parameter for the API calls made - https://api.testcollab.io/projects?token=<generated-API-token>    - <b>Bearer authentication</b> (also called token authentication) is an HTTP authentication scheme that involves security tokens called bearer tokens. You can generate bearer auth token using [Login](#operation/login) API.     Send this token as the Authorization header while making requests to protected resources:     `Authorization: Bearer <token>`    For making API calls, we recommend using the <b>API token</b> generated from user profile page as it won't affect the on-going user session and will be available until it is revoked by the user who generated it.      # Error Handling Error responses   - `Not Found` - Error is sent when requested resource is not available.   - `Unauthorized - invalid token` - Error is sent when API token sent with the request is invalid or revoked. Error contains status code 401        - `Forbidden` - Error is sent when logged in user is not part of the company, project or his role does not allow to complete given action. Response consist of 403 status code and more information is given in error message. 
 *
 * OpenAPI spec version: 2.3.1
 * Contact: support@testcollab.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from '../runtime';
import {
    Company,
    CompanyFromJSON,
    CompanyToJSON,
    ProjectUserMinified,
    ProjectUserMinifiedFromJSON,
    ProjectUserMinifiedToJSON,
    Token,
    TokenFromJSON,
    TokenToJSON,
    Upload,
    UploadFromJSON,
    UploadToJSON,
    UserPreference,
    UserPreferenceFromJSON,
    UserPreferenceToJSON,
} from './';

/**
 * 
 * @export
 * @interface UserMy
 */
export interface UserMy {
    /**
     * 
     * @type {number}
     * @memberof UserMy
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof UserMy
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof UserMy
     */
    aboutMe?: string;
    /**
     * If email is modified then a confirmation should be sent 
     * @type {string}
     * @memberof UserMy
     */
    email: string;
    /**
     * 
     * @type {Upload}
     * @memberof UserMy
     */
    avatar?: Upload;
    /**
     * 
     * @type {string}
     * @memberof UserMy
     */
    username?: string;
    /**
     * 
     * @type {Date}
     * @memberof UserMy
     */
    lastActive?: Date;
    /**
     * 
     * @type {boolean}
     * @memberof UserMy
     */
    confirmed?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UserMy
     */
    rank?: UserMyRankEnum;
    /**
     * 
     * @type {Token}
     * @memberof UserMy
     */
    token?: Token;
    /**
     * 
     * @type {Array<ProjectUserMinified>}
     * @memberof UserMy
     */
    projects?: Array<ProjectUserMinified>;
    /**
     * 
     * @type {Array<Company>}
     * @memberof UserMy
     */
    companies?: Array<Company>;
    /**
     * 
     * @type {UserPreference}
     * @memberof UserMy
     */
    preferences?: UserPreference;
    /**
     * 
     * @type {string}
     * @memberof UserMy
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof UserMy
     */
    isGuest?: number;
    /**
     * 
     * @type {number}
     * @memberof UserMy
     */
    isCopilot?: number;
    /**
     * HMAC SHA256 hash to verify user identity with Intercom
     * @type {string}
     * @memberof UserMy
     */
    intercomHash?: string;
}

export function UserMyFromJSON(json: any): UserMy {
    return {
        'id': json['id'],
        'name': json['name'],
        'aboutMe': !exists(json, 'about_me') ? undefined : json['about_me'],
        'email': json['email'],
        'avatar': !exists(json, 'avatar') ? undefined : UploadFromJSON(json['avatar']),
        'username': !exists(json, 'username') ? undefined : json['username'],
        'lastActive': !exists(json, 'last_active') ? undefined : new Date(json['last_active']),
        'confirmed': !exists(json, 'confirmed') ? undefined : json['confirmed'],
        'rank': !exists(json, 'rank') ? undefined : json['rank'],
        'token': !exists(json, 'token') ? undefined : TokenFromJSON(json['token']),
        'projects': !exists(json, 'projects') ? undefined : (json['projects'] as Array<any>).map(ProjectUserMinifiedFromJSON),
        'companies': !exists(json, 'companies') ? undefined : (json['companies'] as Array<any>).map(CompanyFromJSON),
        'preferences': !exists(json, 'preferences') ? undefined : UserPreferenceFromJSON(json['preferences']),
        'createdAt': !exists(json, 'created_at') ? undefined : json['created_at'],
        'isGuest': !exists(json, 'is_guest') ? undefined : json['is_guest'],
        'isCopilot': !exists(json, 'is_copilot') ? undefined : json['is_copilot'],
        'intercomHash': !exists(json, 'intercom_hash') ? undefined : json['intercom_hash'],
    };
}

export function UserMyToJSON(value?: UserMy): any {
    if (value === undefined) {
        return undefined;
    }
    return {
        'id': value.id,
        'name': value.name,
        'about_me': value.aboutMe,
        'email': value.email,
        'avatar': UploadToJSON(value.avatar),
        'username': value.username,
        'last_active': value.lastActive === undefined ? undefined : value.lastActive.toISOString(),
        'confirmed': value.confirmed,
        'rank': value.rank,
        'token': TokenToJSON(value.token),
        'projects': value.projects === undefined ? undefined : (value.projects as Array<any>).map(ProjectUserMinifiedToJSON),
        'companies': value.companies === undefined ? undefined : (value.companies as Array<any>).map(CompanyToJSON),
        'preferences': UserPreferenceToJSON(value.preferences),
        'created_at': value.createdAt,
        'is_guest': value.isGuest,
        'is_copilot': value.isCopilot,
        'intercom_hash': value.intercomHash,
    };
}

/**
* @export
* @enum {string}
*/
export enum UserMyRankEnum {
    User = 'User',
    Administrator = 'Administrator'
}


